import {
  Condition,
  MetafieldMatchType,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const isValidRegex = (regex: string) => {
  try {
    new RegExp(regex);
    return true;
  } catch {
    return false;
  }
};

export type ProductVariantMetafieldState = Omit<
  Condition.ProductVariantMetafield,
  "type"
>;

export const PRODUCT_VARIANT_METAFIELD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductVariantMetafieldState>
  >,
): ConditionType<
  ProductVariantMetafieldState,
  Condition.ProductVariantMetafield
> => ({
  name: "Product variant metafield",
  description(state) {
    return `Metafield: ${state.namespace}.${state.key}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductVariantMetafieldState>) {
    return React.createElement(Details, props);
  },
  empty: {
    namespace: "",
    key: "",
    comparison: MetafieldMatchType.EXACT,
    value: "",
  },
  fromModel(model: Condition.ProductVariantMetafield) {
    return { ...model };
  },
  toModel(state) {
    return { type: Condition.PRODUCT_VARIANT_METAFIELD, ...state };
  },
  valid(state) {
    if (state.comparison === MetafieldMatchType.REGEX) {
      return isValidRegex(state.value);
    }
    return true;
  },
});
